import { api } from "../../apiendpoints/index";
import axios from "../../axiosMiddleware";

// User
export const GetUserDetail = async () => {
  return axios.get(`${api.USER.USER_DETAIL}`);
};

export const SaveChangePassword = async (data) => {
  return axios.post(`${api.USER.CHANGE_PASSWORD}`, data);
};
